module.exports = __webpack_public_path__ + "img/reward-btn1.8941524d.png";